import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-password-field',
  templateUrl: './password-field.component.html',
  styleUrls: ['./password-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordFieldComponent),
      multi: true
    },
  ]
})
export class PasswordFieldComponent implements ControlValueAccessor {
  @Input() formControlName: string;
  @Input() placeholder: string;
  @Input() autoCompletePassword = 'new-password';

  public isPasswordVisible = false;

  private _value = '';

  public set value (value) {
    this._value = value;

    this.onChange(value);
  }

  public get value (): string {
    return this._value;
  }

  public onChangePassword (event: Event) {
    const password = event.target['value'];
    if (typeof password === 'string') {
      this.value = password;
    }
  }

  public onChangePasswordVisibility () {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  public onChange = (password: string) => {};

  public onTouched = () => {};

  public writeValue(password: string): void {
    this.value = password;
  }

  registerOnChange(fn: (password: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
